import React, { Suspense } from "react";
import { Flex, Link, Spinner, Text } from "@chakra-ui/react";
import SVG from "react-inlinesvg";
import MyDashboardChart from "@/features/my-dashboard/components/chart/MyDashboardChart";
import MyDashboardLineSheetList from "@/features/my-dashboard/components/MyDashboardLineSheetList";
import CenteredSpinner from "@/shared/components/centered-spinner";

function MyDashboardMainSection() {
  return (
    <Flex
      padding={"16px"}
      flexDirection={"column"}
      boxShadow={"0 2px 4px 0 rgba(0, 0, 0, 0.10)"}
      position={"relative"}
      borderRadius={"8px"}
      background={"#FFFFFF"}
      minHeight={"600px"}
      sx={{
        "&::before": {
          content: '""',
          position: "absolute",
          inset: 0,
          boxShadow: "0 0 0 0.5px #D4D4D1",
          borderRadius: "8px",
          pointerEvents: "none",
          zIndex: 1,
        },
      }}
    >
      <Suspense fallback={<CenteredSpinner />}>
        <MyDashboardChart />
      </Suspense>
      <Suspense fallback={<CenteredSpinner />}>
        <MyDashboardLineSheetList />
      </Suspense>
    </Flex>
  );
}

export default MyDashboardMainSection;
